module.exports = __webpack_public_path__ + "img/Insoles.2e1e9a74.svg";